import { Grid } from '@mui/material';
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import TextFieldComponent from '../../../../../Components/TextFieldComponent';
import MobileNumberField from '../../../../../Components/MobileNumberField';
import { ClientContactList, CreateClientContact } from '../../../../../redux/Thunk/ClientModule/ClientThunk';
import { useDispatch } from 'react-redux';
import { validateFields } from '../../../../../Helper/ValidateFields';
import { formatInternationalMobile } from "../../../../../Helper/phone";

const CreateClient = forwardRef(({ clientId, onSuccess }, ref) => {
    const initialState = useMemo(() => ({
        iClientId: clientId || "",
        vFirstName: "",
        vLastName: "",
        vEmail: "",
        vSkype: "",
        mobile: {
            countryIso: "US",
            phoneCode: "1",
            number: "",
            nicename: "",
        },
        vJobTitle: "",
    }), [clientId]);
    const dispatch = useDispatch();
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState(initialState);
    const formRef = useRef(null);

    useEffect(() => {
        setFormData(initialState);
        setErrors({});
    }, [initialState]);

    useImperativeHandle(ref, () => ({
        submit: () => {
            if (formRef.current?.requestSubmit) {
                formRef.current.requestSubmit();
            } else {
                formRef.current?.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
            }
        },
    }));
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }

    const formFields = [
        { name: "vFirstName", label: "First Name" },
        { name: "vLastName", label: "Last Name" },
        { name: "vEmail", label: "Email" },

    ];
    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission
        const newErrors = validateFields(formData, formFields);
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        const { mobile, ...formDataWithoutMobile } = formData; // Exclude mobile field
        const payload = {
            ...formDataWithoutMobile,
            vPhone: JSON.stringify({
                countryTitle: `${formData.mobile.nicename}`,
                countryFlagClass: `iti-flag ${formData.mobile.countryIso.toLowerCase()}`,
                mobileNumber: formatInternationalMobile({
                    phoneCode: formData.mobile.phoneCode,
                    number: formData.mobile.number,
                }),
            }), // Mobile number details
        }
        const res = await dispatch(CreateClientContact(payload));
        if (res?.payload) {
            dispatch(ClientContactList(clientId));
            setFormData(initialState);
            onSuccess?.(res.payload);
        }
    }
    return (
        <>
            <form ref={formRef} onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <TextFieldComponent
                            type="text"
                            name="vFirstName"
                            label="First Name"
                            value={formData.vFirstName}
                            onChange={handleInputChange}
                            error={errors.vFirstName || ""}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextFieldComponent
                            type="text"
                            name="vLastName"
                            label="Last Name"
                            value={formData.vLastName}
                            onChange={handleInputChange}
                            error={errors.vLastName || ""}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextFieldComponent
                            type="text"
                            name="vEmail"
                            label="Email"
                            value={formData.vEmail}
                            onChange={handleInputChange}
                            error={errors.vEmail || ""}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                    <MobileNumberField
                            id="mobile"
                            name="mobile"
                            label="Mobile"
                            value={formData.mobile}
                            onChange={handleInputChange}
                            error={errors?.mobile || ""}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextFieldComponent
                            type="text"
                            name="vSkype"
                            label="Slack/Teams"
                            value={formData.vSkype}
                            onChange={handleInputChange}
                            error={errors.vSkype || ""}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextFieldComponent
                            type="text"
                            name="vJobTitle"
                            label="Job Title"
                            value={formData.vJobTitle}
                            onChange={handleInputChange}
                            error={errors.vJobTitle || ""}
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </form>
        </>
    );
});

export default CreateClient;